import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownButton, DropdownButtonContext } from '@dixa/lib-shared-habla';
import { useEffect, useMemo, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { TranslateTextLanguageSelectionList, } from 'components/translateTextLanguageSelectionList';
import { languageCodesToSelectionListValue, } from 'utils/useLanguageSelectionList';
import { useTranslateText, } from 'utils/useTranslateText';
/**
 * Represents a dropdown component for translating given text to a selected
 * language.
 */
export const TranslateTextDropdownButton = (props) => {
    const { message, onTranslateStart, onTranslateEnd, onTranslateError, onRevert, } = props;
    const [selectedLanguageCode, setSelectedLanguageCode] = useState(props.selectedLanguageCode);
    useEffect(() => setSelectedLanguageCode(props.selectedLanguageCode), [props.selectedLanguageCode]);
    const selectedLanguage = useMemo(() => {
        return selectedLanguageCode
            ? languageCodesToSelectionListValue([selectedLanguageCode])[0]
            : undefined;
    }, [selectedLanguageCode]);
    const [translate, { asyncStatus, translatedText, error }] = useTranslateText();
    const isTranslating = asyncStatus === 'pending';
    useEffect(() => {
        if (asyncStatus === 'uninitialized') {
            return;
        }
        if (selectedLanguage && asyncStatus === 'pending') {
            onTranslateStart === null || onTranslateStart === void 0 ? void 0 : onTranslateStart({ selectedLanguage, originalText: message });
        }
        if (selectedLanguage && translatedText && asyncStatus === 'fulfilled') {
            onTranslateEnd === null || onTranslateEnd === void 0 ? void 0 : onTranslateEnd({
                originalText: message,
                selectedLanguage,
                translatedText,
            });
        }
        if (selectedLanguage && error && asyncStatus === 'rejected') {
            onTranslateError === null || onTranslateError === void 0 ? void 0 : onTranslateError({ error, originalText: message, selectedLanguage });
        }
        // Only care about the async status
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [asyncStatus]);
    // Handles translating and reverting.
    useEffect(() => {
        if (selectedLanguage) {
            translate({ language: selectedLanguage.name, text: message }).catch((error) => {
                console.warn('Could not translate: ', error);
            });
        }
        else {
            onRevert === null || onRevert === void 0 ? void 0 : onRevert();
        }
        // Only run when selected language changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedLanguage]);
    const dropdown = useMemo(() => (_jsx(DropdownButtonContext.Consumer, { children: (dropdownProps) => (_jsx(TranslateTextLanguageSelectionList, { autoFocusSearch: dropdownProps.dropdownOpen, selectedLanguageCode: selectedLanguageCode, onRevert: onRevert, onLanguageChange: (event) => {
                if (event.selectedLanguage) {
                    analytics.agentCopilotTranslateMessageLanguageSelected({
                        language: event.selectedLanguage.name,
                        context: 'singleMessage',
                    });
                    setSelectedLanguageCode(event.selectedLanguage.code);
                    dropdownProps.closeDropdown();
                }
            } })) })), [selectedLanguageCode, onRevert]);
    return (_jsx(DropdownButton, { fixed: true, noArrow: true, icon: "translate", buttonProps: {
            isLoading: isTranslating,
            disabled: isTranslating,
        }, dropdown: dropdown }));
};
